<script setup lang="ts">
import WrButton from "~/components/global/WrButton.vue";

const colorMode = useColorMode();
const isLight = computed(() => colorMode.value !== "dark");

defineProps<{
  text: string;
  ctaText: string;
}>();

defineEmits<{
  (e: "cta-clicked"): void;
}>();
</script>

<template>
  <div class="mt-24 lg:mt-[100px] mb-16 lg:mb-[100px] text-center">
    <div class="max-w-[700px] mx-auto px-4">
      <p
        class="text-center italic font-avant text-[18px] lg:text-[20px] leading-relaxed"
        :class="isLight ? 'text-[#501D71]' : 'text-[#CDA0FE]'"
      >
        "{{ text }}"
      </p>
    </div>

    <div class="flex justify-center mt-16">
      <WrButton
        @click="$emit('cta-clicked')"
        container-class="h-[48px]"
        append-class="text-base font-normal px-6"
      >
        {{ ctaText }}
      </WrButton>
    </div>
  </div>
</template>
